module.exports = __webpack_public_path__ + "static/media/tour-2.f2ff80af.jpg";